import { fromHttpPromise } from 'pulse/adapters';
import { persistedFetchFrameworkTypes } from 'fdsr-migration-layer';
import { createRpcClientV2 } from 'rpc-client-utils';
import type { InboundDbObjectType } from 'inbound-db-meta-service-client/InboundDbMeta-Service/types';
import type { NoParams } from 'pulse/resources';
import { PromiseClient } from 'hub-http/adapters/promiseClient';

export const defaultObjectTypeDefinitionsResolver = fromHttpPromise<
  InboundDbObjectType[],
  NoParams
>('objectTypeDefinitionsResolver', (httpClient) =>
  persistedFetchFrameworkTypes.makeFetchWithOpts({ refresh: true })({
    family: 'objects',
    httpClient: httpClient as PromiseClient,
    // Passing rpcClient here fixes downstream object-type consumers under the
    // CHIRP migration (crm-object-map #258, framework-app-settings-features-lib,
    // etc.). TODO: remove suppression once the migrated fdsr-migration-layer
    // publishes — its published type does not yet accept rpcClient.
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore rpcClient not yet in published fetchFrameworkTypes type
    rpcClient: createRpcClientV2({
      hubHttpClient: httpClient as PromiseClient,
    }),
  })
);
